import  { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { Observable } from "rxjs";

import { JwtHelperService } from "@auth0/angular-jwt";
import { MainService } from "../Services/service.service";
import { getAuthToken } from "../api/AuthHeaders";

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {
  constructor(private jwtHelper: JwtHelperService, private services: MainService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise<boolean>((rs, rj) => {
      var token = getAuthToken();

      if (token && !this.jwtHelper.isTokenExpired(token)) {
        console.log("g-true");
        return rs(true);
      }
      if (state.url) {
        //this.services.showLogin(next.url[0].path);
        this.services.showLogin(state.url);
      } else {
        this.services.showLogin('/my-ads');
      }
      console.log("g-false");
      return rs(false);
    });
  }
}
